export class BufferQueue {
    get length() {
        return this.queue.length + this.currentlyProcessing.size;
    }
    add(item) {
        this.queue.push(item);
        this.triggerProcessing();
    }
    process() {
        this.triggeredProcessing = false;
        while(this.currentlyProcessing.size < this.maxConcurrent && this.queue.length > 0){
            const item = this.queue.shift();
            if (item == undefined) continue; // ts only
            const itemPromise = this.onProcessItem(item);
            void itemPromise.finally(()=>{
                this.currentlyProcessing.delete(itemPromise);
                this.triggerProcessing();
            });
            this.currentlyProcessing.add(itemPromise);
        }
    }
    triggerProcessing() {
        if (this.triggeredProcessing) return;
        this.triggeredProcessing = true;
        setTimeout(()=>this.process(), 0) // start processing in the next loop to allow the server to handle other things
        ;
    }
    constructor(maxConcurrent, onProcessItem){
        this.queue = [];
        this.triggeredProcessing = false;
        this.currentlyProcessing = new Set();
        this.maxConcurrent = maxConcurrent;
        this.onProcessItem = onProcessItem;
    }
}
